var map = {
	"./giropay.png": "c070",
	"./klarna.png": "eaad",
	"./klarna_paynow.png": "29ce",
	"./paypal.png": "9fd0",
	"./paywithgoogle.png": "a257",
	"./sepadirectdebit.png": "c584"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5963";